
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mba-ai-product-management",
      function () {
        return require("private-next-pages/mba-ai-product-management/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mba-ai-product-management"])
      });
    }
  